import { mean } from 'lodash';
import { type FC, useMemo } from 'react';

import { useSelectionsPanelContext } from '@/features/selectionsPanel/selectionsPanelProvider';
import type { IRealEstateFeature } from '@/models/features';
import { convertMoney } from '@/utils/common';
import { isDefined } from '@/utils/guards';

import { ListingCard } from '../selectionCard/cardVariants/listingCard';
import { PanelSectionDropdown } from './panelSectionDropdown';

export const ListingsSectionDropdown: FC = () => {
  const { selectedListings } = useSelectionsPanelContext();

  const listingsCount = useMemo(
    () => selectedListings.length,
    [selectedListings.length]
  );

  const selectionCards = useMemo(() => {
    return (
      <>
        {selectedListings.map((feature: IRealEstateFeature, index) => (
          <ListingCard key={feature.id} feature={feature} index={index + 1} />
        ))}
      </>
    );
  }, [selectedListings]);

  const averagePricePerAcre = useMemo(() => {
    const getListingPricePerAcre = (listing: IRealEstateFeature) =>
      Number(listing.properties.price_per_acre) || null;

    return mean(selectedListings.map(getListingPricePerAcre).filter(isDefined));
  }, [selectedListings]);

  if (!listingsCount) return null;

  return (
    <PanelSectionDropdown
      sectionCount={listingsCount}
      subtitle={`${convertMoney(averagePricePerAcre)} - Mean PPA`}
      title="Listings"
    >
      {selectionCards}
    </PanelSectionDropdown>
  );
};
